var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuid } from 'uuid';
import { createMessageListenerMiddleware } from '../middleware';
export var WIDGET_FEATURE_KEY = 'widget';
var defaultInitialWidgetState = {
    initialized: false,
    formSubmitted: false,
    sessionId: uuid(),
    userDetails: {},
};
export var createWidgetStore = function (initialState) {
    if (initialState === void 0) { initialState = defaultInitialWidgetState; }
    var widgetSlice = createSlice({
        name: WIDGET_FEATURE_KEY,
        initialState: initialState,
        reducers: {
            startNewSession: function (state) {
                state.sessionId = uuid();
            },
            setHostDetails: function (state, action) {
                state.initialized = true;
                state.hostDetails = action.payload;
            },
            setUserDetails: function (state, action) {
                state.userDetails = __assign(__assign({}, state.userDetails), action.payload);
            },
            seAppointmentDetails: function (state, action) {
                state.appointmentDetails = __assign(__assign({}, state.appointmentDetails), action.payload);
            },
            setFormSubmitted: function (state, action) {
                state.formSubmitted = action.payload;
            },
            reset: function () { return defaultInitialWidgetState; },
        },
    });
    var widgetStoreReducer = widgetSlice.reducer;
    var widgetActions = widgetSlice.actions;
    var messageListenerMiddleware = createMessageListenerMiddleware(function (event, store) {
        var _a, _b, _c;
        if (event.data.type.endsWith('initialize')) {
            store.dispatch(widgetActions.setHostDetails(event.data.payload));
            Object.keys(((_c = (_b = (_a = event.data) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.vars) || {}).forEach(function (key) {
                if (typeof key === 'string' ||
                    typeof key === 'number' ||
                    typeof key === 'boolean') {
                    window[key] =
                        event.data.payload.config.vars[key];
                }
            });
        }
    });
    return {
        WIDGET_FEATURE_KEY: WIDGET_FEATURE_KEY,
        widgetStoreReducer: widgetStoreReducer,
        widgetActions: widgetActions,
        messageListenerMiddleware: messageListenerMiddleware,
    };
};
